<template>
  <div class="d-flex flex-column justify-start align-start title-loader">
    <v-skeleton-loader
      type="image"
      height="48px"
      width="73px"
      class="mb-1"
    />
    <div class="d-flex align-start justify-start cards-loader">
      <v-skeleton-loader
        type="image"
        height="206px"
        width="220px"
        class="mr-4"
      />
      <v-skeleton-loader
        type="image"
        height="206px"
        width="220px"
        class="mr-4"
      />
      <v-skeleton-loader
        type="image"
        height="206px"
        width="220px"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeLearnSkeletonLoader',
};
</script>

<style scoped lang="less">
:deep(.v-skeleton-loader__image) {
  border-radius: 4px;
}
.title-loader {
  :deep(.v-skeleton-loader__image) {
    height: 48px;
  }
}

.cards-loader {
  :deep(.v-skeleton-loader__image) {
    height: 206px;
  }
}
</style>
